import { useRemoteClientGet } from '@/configs/http-client';
import { useQuery } from '@tanstack/react-query';

const { remoteClientGet } = useRemoteClientGet();

interface FetchDataQueryParams {
  keyPrefix: string; 
  url: string;
  page?: number;
  pageSize?: number;
  filters?: Record<string, any>;
}

export function useFetchDataQuery({ keyPrefix, url, page = 1, pageSize = 10, filters = {} }: FetchDataQueryParams) {
  return useQuery({
    queryKey: [keyPrefix, url, page, pageSize, filters],
    queryFn: () => remoteClientGet(url, { params: { page, pageSize, ...filters } }),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
}
